<template>
  <nav aria-label="Breadcrumb" class="mb-6">
    <ol class="flex flex-wrap items-center gap-1 text-sm text-muted">
      <li>
        <NuxtLink :to="shopPath('/')" class="hover:text-primary-600 transition-colors">
          Acasă
        </NuxtLink>
      </li>
      <li v-for="(item, index) in items" :key="index" class="flex items-center gap-1">
        <UIcon name="i-heroicons-chevron-right" class="w-4 h-4 text-dimmed" />
        <NuxtLink
          v-if="item.to && index < items.length - 1"
          :to="shopPath(item.to)"
          class="hover:text-primary-600 transition-colors"
          @mouseenter="prefetchRoute(shopPath(item.to!))"
          @focus="prefetchRoute(shopPath(item.to!))"
        >
          {{ item.label }}
        </NuxtLink>
        <span v-else class="text-highlighted font-medium">{{ item.label }}</span>
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
const shopPath = useShopPath()
defineProps<{
  items: { label: string, to?: string }[]
}>()

const { prefetchRoute } = useRoutePrefetch()
</script>
